import ReactHtmlParser from 'html-react-parser';

function HtmlRender({ text }: { text: string }) {
	return ReactHtmlParser(text);
}

export default HtmlRender;
